import { MAX_LOGGED_IN_PROFILES } from 'src/constants';
import { normalizeEmail } from 'src/helpers/email_helpers';
import type { MenuListDataType } from 'src/components/Profiles/DropdownItem.types';

/**
 * Finds a saved profile by email, ignoring case and surrounding whitespace.
 */
export const findProfileByEmail = (
	list: MenuListDataType[],
	email?: string | null,
): MenuListDataType | undefined => {
	const normalized = normalizeEmail(email);
	if (!normalized) return undefined;
	return list.find((profile) => normalizeEmail(profile.email) === normalized);
};

/**
 * Whether adding another saved account would exceed {@link MAX_LOGGED_IN_PROFILES}.
 * @param profileCount - Currently stored profiles
 * @param replacingCurrent - True when the active profile will be removed first
 */
export const isLoggedInProfilesLimitReached = (
	profileCount: number,
	replacingCurrent = false,
): boolean => profileCount - (replacingCurrent ? 1 : 0) >= MAX_LOGGED_IN_PROFILES;
